import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table } from 'antd';
import moment from 'moment';

import {
  queryCancelCustomProtection,
  queryCustomDepartmentList,
  queryDepartmentMy,
  queryDepartmentProduct,
  queryMyCustomProtectionList,
  querySaveCustomProtection,
} from '@api/crm/crm';
import ModalProtect from './ModalProtect';

const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pageNo: 1,
      product: [],
      total: 0,
      modalVisible: false,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.getMyDepartment();
    this.getProtection();
  }

  saveProtection = params => {
    querySaveCustomProtection(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getProtection();
        this.handleModalVisible(false);
      } else {
        message.error(res.message);
      }
    });
  };

  getProtection = pageNo => {
    const no = this.state.pageNo;
    const current = pageNo || no;
    this.setState({
      pageNo: current,
    });
    queryMyCustomProtectionList({
      condition: this.condition || '',
      type: this.type || '',
      start: current,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
          total: res.totalSize,
        });
      }
    });
  };

  getMyDepartment = () => {
    queryDepartmentMy().then(res => {
      if (res.statusCode === 200) {
        const { uuid } = res.data;
        this.getProduct(uuid);
        this.getMyCustom(uuid);
      }
    });
  };

  getMyCustom = () => {
    queryCustomDepartmentList().then(res => {});
  };

  getProduct = uuid => {
    queryDepartmentProduct({
      uuid,
    }).then(res => {
      this.setState({
        product: res.data,
      });
    });
  };

  handleModalVisible = (flag, uuid) => {
    this.uuid = uuid;
    this.setState({
      modalVisible: !!flag,
    });
  };

  handleSubmit = params => {
    this.saveProtection(params);
  };

  handleSearch = e => {
    if (e) {
      e.preventDefault();
    }
    this.props.form.validateFields((err, values) => {
      this.condition = values.condition;
      this.getProtection(1);
    });
  };

  confirm = customUuid => {
    return e => {
      queryCancelCustomProtection({
        customUuid,
      }).then(res => {
        if (res.statusCode === 200) {
          message.success(res.message);
          this.getProtection();
          this.handleModalVisible(false);
        } else {
          message.error(res.message);
        }
      });
    };
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form layout="inline" onSubmit={this.handleSearch}>
        <Row gutter={{ md: 8, lg: 24, xl: 48 }} style={{ minWidth: '650px' }}>
          <Col md={8} sm={24} style={{ minWidth: '400px' }}>
            <FormItem label="客户名称">
              {getFieldDecorator('condition')(
                <Input placeholder="请输入" style={{ minWidth: '200px' }} />,
              )}
            </FormItem>
          </Col>
          <Col md={8} sm={24}>
            <span className="submitButtons">
              <Button type="primary" htmlType="submit">
                查询
              </Button>
              <Button style={{ marginLeft: 8 }} onClick={this.handleFormReset}>
                重置
              </Button>
            </span>
          </Col>
        </Row>
      </Form>
    );
  };

  columns = () => {
    return [
      {
        title: '编号',
        dataIndex: 'uuid',
        render: (text, record, index) => {
          return <span>{index + 1}</span>;
        },
      },
      {
        title: '客户名称',
        dataIndex: 'name',
      },
      {
        title: '行业',
        dataIndex: 'type',
      },
      {
        title: '来源渠道',
        dataIndex: 'origin',
      },
      {
        title: '保护时间',
        dataIndex: 'protectDate',
        render: text => <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>,
      },
      {
        title: '保护到期时间',
        dataIndex: 'maturityDate',
        render: text => <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>,
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => {
          return (
            <Popconfirm title="确定取消该客户保护?" onConfirm={() => this.confirm(record.uuid)}>
              <a>取消保护</a>
            </Popconfirm>
          );
        },
      },
    ];
  };

  render() {
    const { data, modalVisible, product, total, pageNo } = this.state;
    const parentProps = {
      handleModalVisible: this.handleModalVisible,
      handleSubmit: this.handleSubmit,
      product,
      uuid: this.uuid,
    };
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: pageNo,
      onChange: current => {
        this.getProtection(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <Card>
        <div className="tableList">
          <div className="tableListForm">{this.renderSearchForm()}</div>
          <div className="tableListOperator">
            <Button type="primary" onClick={() => this.handleModalVisible(true)}>
              添加
            </Button>
          </div>
        </div>
        <Table
          rowKey="uuid"
          rowSelection={{}}
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
        />
        {modalVisible ? <ModalProtect {...parentProps} /> : null}
      </Card>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/crm/custom/protect/Index.js